/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Guest-User specific serializer that is limited to the Guest-User
 * specific fields.
 * @export
 * @interface APIGuestUser
 */
export interface APIGuestUser {
    /**
     * 
     * @type {string}
     * @memberof APIGuestUser
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestUser
     */
    readonly self: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIGuestUser
     */
    readonly isGuestUser: boolean;
    /**
     * This is the username used for a guest user.
     * @type {string}
     * @memberof APIGuestUser
     */
    readonly guestId: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIGuestUser
     */
    readonly organization: string;
    /**
     * 
     * @type {Date}
     * @memberof APIGuestUser
     */
    createdAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof APIGuestUser
     */
    readonly timeToLive: number;
    /**
     * 
     * @type {string}
     * @memberof APIGuestUser
     */
    repFor?: string;
    /**
     * 
     * @type {string}
     * @memberof APIGuestUser
     */
    comment?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIGuestUser
     */
    readonly preferences: { [key: string]: any; };
    /**
     * Designates whether this user should be treated as active. Unselect this instead of deleting accounts.
     * @type {boolean}
     * @memberof APIGuestUser
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIGuestUser
     */
    readonly roles: string;
}

/**
 * Check if a given object implements the APIGuestUser interface.
 */
export function instanceOfAPIGuestUser(value: object): value is APIGuestUser {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('isGuestUser' in value) || value['isGuestUser'] === undefined) return false;
    if (!('guestId' in value) || value['guestId'] === undefined) return false;
    if (!('organization' in value) || value['organization'] === undefined) return false;
    if (!('timeToLive' in value) || value['timeToLive'] === undefined) return false;
    if (!('preferences' in value) || value['preferences'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function APIGuestUserFromJSON(json: any): APIGuestUser {
    return APIGuestUserFromJSONTyped(json, false);
}

export function APIGuestUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIGuestUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'self': json['self'],
        'isGuestUser': json['is_guest_user'],
        'guestId': json['guest_id'],
        'organization': json['organization'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'timeToLive': json['time_to_live'],
        'repFor': json['rep_for'] == null ? undefined : json['rep_for'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'preferences': json['preferences'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'roles': json['roles'],
    };
}

export function APIGuestUserToJSON(value?: Omit<APIGuestUser, 'id'|'self'|'is_guest_user'|'guest_id'|'organization'|'time_to_live'|'preferences'|'roles'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'rep_for': value['repFor'],
        'comment': value['comment'],
        'is_active': value['isActive'],
    };
}

